import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { getMBMPointData } from "services/ConfigServices";
import { methodData, displayData, monthnameData } from "variables/MBM/lists/pointdata";
import { pointdatapagetext } from "variables/MBM/pointdata";
import { dico } from "variables/lists/dico";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const HighchartsContainer = styled.div`
  margin-top: 1.5rem;
  margin-right: 1rem;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewPointDataDialog(props) {
  const { closeModal, point } = props;

  const [method, setMethod] = useState("raw");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'month').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [display, setDisplay] = useState("tab");
  const [data, setData] = useState([]);
  const [highchartData, setHighchartData] = useState([]);
  const [datesdata, setDatesdata] = useState([]);
  const [daterange, setDaterange] = useState("0");
  const classes = useStyles();

  const handleMethodChange = (event) => {
    if (method === 'raw') {
      setDatebegin(datesdata.find((obj) => obj.id === "0").datebegin);
      setDateend(datesdata.find((obj) => obj.id === "0").dateend);
      setDaterange("0");
    }
    setMethod(event.target.value);
  };
  const handleDisplayChange = (event) => { setDisplay(event.target.value); };
  const handleDaterangeChange = (event) => {
    setDatebegin(datesdata.find((obj) => obj.id === event.target.value).datebegin);
    setDateend(datesdata.find((obj) => obj.id === event.target.value).dateend);
    setDaterange(event.target.value);
  };

  useEffect(() => {
    axios
      .get(getMBMPointData(method === 'raw' ? point.id : point.pointid, datebegin, dateend, method), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setData(res.data);
        const highdata = res.data.map((item) => {
          let dataobj = [];
          dataobj.push(item.date);
          dataobj.push(Number(item.value));
          return dataobj;
        });
        setHighchartData(highdata);
      });

  }, [method, datebegin, dateend]);

  useEffect(() => {
    let datesdatatmp = [];
    let nowmoment = moment();
    datesdatatmp.push({ id: "0", name: "1 mois glissant", datebegin: nowmoment.subtract(1, 'month').format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    for (let i = 1; i <= 24; i++) {
      let substractedmoment = moment().subtract(i, 'month');
      console.log(i,substractedmoment);  
      let month = monthnameData.find((obj) => obj.id === substractedmoment.format("MMMM")).name;
      console.log(i,month);  
      let year = substractedmoment.format("YYYY");
      console.log(i,year);  
      let datebeginstr = substractedmoment.set('date', 1).format("YYYY-MM-DD");
      console.log(i,datebeginstr);  
      let dateendstr = substractedmoment.add(1, 'month').set('date', 1).subtract(1, 'day').format("YYYY-MM-DD"); //go to the end of month
      console.log(i,dateendstr);  
      datesdatatmp.push({ id: "" + i, name: month + " " + year, datebegin: datebeginstr, dateend: dateendstr });
    }
    setDatesdata(datesdatatmp);
  }, []);


  const columns = [
    {
      name: pointdatapagetext.date,
      selector: (row) => row.date,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.date && moment(row.date).isValid()
          ? moment(row.date).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: pointdatapagetext.value,
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.value ? new Intl.NumberFormat('fr-FR').format(row.value) : ""
    },
  ]

  const optionsColumnChart = {
    chart: {
      zoomType: "x",
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  const optionsLineChart = {
    chart: {
      zoomType: "x",
      type: "line",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  return (
    <>
      <form className={classes.root}>
        {point &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.method}
                  selectValue={method}
                  handleSelectValueChange={handleMethodChange}
                  data={methodData}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.daterange}
                  selectValue={daterange}
                  handleSelectValueChange={handleDaterangeChange}
                  data={datesdata}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.display}
                  selectValue={display}
                  handleSelectValueChange={handleDisplayChange}
                  data={displayData}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {display === 'tab' &&
                <Container>
                  <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                    dense
                    noDataComponent={<NoData>{pointdatapagetext.nodata}</NoData>}
                    noHeader={true}
                    columns={columns}
                    persistTableHead
                    pagination
                    data={data}
                    paginationComponentOptions={{
                      noRowsPerPage: false,
                      rowsPerPageText: "Lignes par page",
                      rangeSeparatorText: "sur",
                      selectAllRowsItem: false,
                      selectAllRowsItemText: "Selectionner toutes les lignes",
                    }}
                  />
                </Container>
              }
              {display === 'barchart' &&
                <HighchartsContainer>
                  <HighchartsReact highcharts={Highcharts} options={optionsColumnChart} />
                </HighchartsContainer>
              }
              {display === 'linechart' &&
                <HighchartsContainer>
                  <HighchartsReact highcharts={Highcharts} options={optionsLineChart} />
                </HighchartsContainer>
              }
            </GridItem>
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewPointDataDialog;
